import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { Globe, CheckCircle2 } from "lucide-react";

const REGIONS = [
  { flag: "🇨🇦", code: "en-ca", label: "Canada (Ontario)", url: "https://betway.com/g/en-ca/sports", verifiedOn: "2026-04-30" },
  { flag: "🇿🇦", code: "co-za", label: "South Africa", url: "https://www.betway.co.za", verifiedOn: "2026-04-30" },
  { flag: "🇬🇧", code: "en-gb", label: "United Kingdom", url: "https://sports.betway.com/en", verifiedOn: null },
  { flag: "🇬🇭", code: "en-gh", label: "Ghana", url: "https://www.betway.com.gh", verifiedOn: null },
  { flag: "🌐", code: "en-global", label: "Global / English", url: "https://betway.com/g/en/sports", verifiedOn: "2026-04-30" },
];

export const TestedRegions = ({ onUse }) => {
  return (
    <section className="nd-card p-6" data-testid="tested-regions-card">
      <div className="flex items-center gap-3 mb-3">
        <Globe className="w-5 h-5" />
        <h2 className="font-display text-xl font-semibold">Tested Betway regions</h2>
      </div>
      <p className="text-sm text-muted-foreground mb-4">
        Verified URLs — the automation's selectors have been probed against these sites.
        Pick the one matching your Betway account and we'll paste it into the URL field.
      </p>

      <ul className="divide-y divide-border" data-testid="tested-regions-list">
        {REGIONS.map((r) => (
          <li
            key={r.code}
            className="py-3 flex items-center justify-between gap-3"
            data-testid={`region-row-${r.code}`}
          >
            <div className="flex items-center gap-3 min-w-0">
              <span className="text-xl" aria-hidden>{r.flag}</span>
              <div className="min-w-0">
                <div className="text-sm text-foreground flex items-center gap-2 flex-wrap">
                  {r.label}
                  {r.verifiedOn ? (
                    <Badge className="bg-success/10 text-success border border-success/40 text-[10px]">
                      <CheckCircle2 className="w-3 h-3 mr-1" />
                      verified {r.verifiedOn}
                    </Badge>
                  ) : (
                    <Badge className="bg-muted text-muted-foreground border border-border text-[10px]">
                      plausible
                    </Badge>
                  )}
                </div>
                <div className="text-xs text-muted-foreground font-tabular truncate">{r.url}</div>
              </div>
            </div>
            <Button
              type="button"
              size="sm"
              variant="outline"
              onClick={() => onUse?.(r.url)}
              data-testid={`region-use-${r.code}`}
              className="h-8 rounded-full px-3 border-border bg-card hover:bg-muted text-foreground shrink-0"
            >
              Use
            </Button>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default TestedRegions;
